"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var RuleValue = function RuleValue(_ref) {
  var errors = _ref.errors,
    id = _ref.id,
    onChange = _ref.onChange,
    type = _ref.type,
    value = _ref.value,
    lookUpValues = _ref.lookUpValues,
    allowsMultipleSelect = _ref.allowsMultipleSelect,
    disabled = _ref.disabled,
    labels = _ref.labels,
    operatorValue = _ref.operatorValue,
    searchableAction = _ref.searchableAction,
    variableOperands = _ref.variableOperands;
  var _computeInputType = (0, _helpers.computeInputType)({
      variableOperands: variableOperands,
      errors: errors,
      id: id,
      onChange: onChange,
      type: type,
      value: value,
      lookUpValues: lookUpValues,
      allowsMultipleSelect: allowsMultipleSelect,
      labels: labels,
      operatorValue: operatorValue
    }),
    ValueInput = _computeInputType.ValueInput,
    inputProps = _computeInputType.inputProps,
    handleOnChange = _computeInputType.handleOnChange;
  return /*#__PURE__*/_react["default"].createElement(ValueInput, _extends({
    errors: errors,
    disabled: disabled,
    id: id,
    onChange: handleOnChange,
    placeholder: labels.ELIGIBILITY_VALUE_PLACEHOLDER || 'Value',
    value: value,
    labels: labels,
    searchableAction: searchableAction
  }, inputProps, {
    className: "simple-rule-value ".concat(inputProps.className)
  }));
};
RuleValue.propTypes = {
  operatorValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  /** If `true`, the input will indicate an error. */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** If `true`, the input will indicate an error. */
  disabled: _propTypes["default"].bool,
  /** Html id. */
  id: _propTypes["default"].string.isRequired,
  /** The list of posible values. */
  lookUpValues: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  /** Flag to indicate weather the operator allows multiple values */
  allowsMultipleSelect: _propTypes["default"].bool,
  /** Callback for when changing the operator. */
  onChange: _propTypes["default"].func.isRequired,
  /** The type of the value in the rule */
  type: _propTypes["default"].oneOf(['string', 'integer', 'double', 'decimal', 'datetime', 'boolean']).isRequired,
  /** The value of the simple rule  */
  value: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** CMS labels */
  labels: _propTypes["default"].shape({
    ELIGIBILITY_VALUE_PLACEHOLDER: _propTypes["default"].string
  }),
  searchableAction: _propTypes["default"].func.isRequired,
  variableOperands: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
RuleValue.defaultProps = {
  variableOperands: [],
  operatorValue: '',
  allowsMultipleSelect: false,
  errors: undefined,
  disabled: false,
  lookUpValues: undefined,
  value: undefined,
  labels: {}
};
RuleValue.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RuleValue",
  "props": {
    "variableOperands": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "operatorValue": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": false
    },
    "allowsMultipleSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate weather the operator allows multiple values",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "If `true`, the input will indicate an error.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will indicate an error.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "lookUpValues": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The list of posible values.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The value of the simple rule",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }, {
          "name": "string"
        }, {
          "name": "instanceOf",
          "value": "Date"
        }]
      },
      "required": false
    },
    "labels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "CMS labels",
      "type": {
        "name": "shape",
        "value": {
          "ELIGIBILITY_VALUE_PLACEHOLDER": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "id": {
      "description": "Html id.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "Callback for when changing the operator.",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "type": {
      "description": "The type of the value in the rule",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'string'",
          "computed": false
        }, {
          "value": "'integer'",
          "computed": false
        }, {
          "value": "'double'",
          "computed": false
        }, {
          "value": "'decimal'",
          "computed": false
        }, {
          "value": "'datetime'",
          "computed": false
        }, {
          "value": "'boolean'",
          "computed": false
        }]
      },
      "required": true
    },
    "searchableAction": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = RuleValue;
exports["default"] = _default;